import {bulkArchiveConnections, bulkUnarchiveConnections} from 'archive/ArchiveActions';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import isArchived from 'archive/isArchived';
import * as contextmenu from 'components/ContextMenu';
import * as Context from 'Context';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import preferences from 'Preferences';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {ConnectionListingGraphQL} from '../../../../graphql-fragments/instruments/__generated/ConnectionListingGraphQL';

export function getContextMenuOptions(
  connection: ConnectionListingGraphQL,
  options: {actionSource?: ActionOrigin}
): Array<contextmenu.ContextMenuOption> {
  return [
    {
      name: 'Open',
      click: () => {
        FileBrowserActions.openFile(connection.id);
      },
    },
    {
      name: 'Archive',
      click: () => {
        ArchiveModal.open({
          analyticsMetadata: options.actionSource ? {actionOrigin: options.actionSource} : {},
          items: [connection],
          onArchive: (itemIds: Array<string>, purpose: string) => {
            bulkArchiveConnections(itemIds, purpose);
          },
        });
      },
      disabled: () => !connection.permissions.archivable,
      hide: () => isArchived(connection),
    },
    {
      name: 'Unarchive',
      click: () => {
        Context.usingAsync(
          options.actionSource
            ? {
                analyticsMetadata: {actionOrigin: options.actionSource},
              }
            : {},
          null,
          () => {
            bulkUnarchiveConnections([connection.id]);
          }
        );
      },
      disabled: () => !connection.permissions.unarchivable,
      hide: () => !isArchived(connection),
    },
    {
      name: 'Copy API ID',
      click: () => {
        copyToClipboard(connection.id, {showToastOnSuccess: true});
      },
      hide: () => !preferences.get('ENABLE_COPY_API_ID'),
    },
  ];
}

export function open(
  e: Event,
  connection: ConnectionListingGraphQL,
  options: {actionSource?: ActionOrigin}
): void {
  contextmenu.view.open(e, getContextMenuOptions(connection, options));
}
